import {
  BasicButton,
  DangerButton,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Modal,
} from "@certn/cascadia-react";
import { t } from "i18next";
import React from "react";

interface Props {
  packageName: string;
  onClose: () => void;
  onConfirm: () => void;
}
export function DeactivatePackageModal({
  packageName,
  onClose,
  onConfirm,
}: Props) {
  const handlePress = () => {
    onConfirm();
    onClose();
  };

  return (
    <Modal testID="package-deactivation-modal" isOpen>
      <Dialog>
        <>
          <DialogHeader onClose={onClose}>
            {t("Deactivate {{name}}", { name: packageName })}
          </DialogHeader>
          <DialogContent>
            {t(
              "By selecting 'Deactivate', you are removing this package from the list of available ordering options. Any cases that have already been ordered with this package will not be impacted. If apply links are using this package they will also be deactivated."
            )}
          </DialogContent>
          <DialogFooter>
            <BasicButton onPress={onClose} testID="close-button">
              {t("Cancel")}
            </BasicButton>
            <DangerButton onPress={handlePress} testID="confirm-button">
              {t("Deactivate")}
            </DangerButton>
          </DialogFooter>
        </>
      </Dialog>
    </Modal>
  );
}
